// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'play';

export const Component = () => (
  <path d='m5.484 3.144 14.751 8.381c.288.24.431.527.431.814 0 .335-.143.575-.43.814L5.483 21.487a.963.963 0 0 1-.526.143.946.946 0 0 1-.67-.287.946.946 0 0 1-.288-.67V3.958c0-.24.096-.48.287-.67A.946.946 0 0 1 4.957 3c.192 0 .384.048.527.144Zm-.526.814v16.715l14.75-8.334-14.75-8.381Z' />
);

export const viewBox = '0 0 25 25';
